import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ProtectedRoute } from "../components/ProtectedRoute";
import { AppProvider } from "./provider";
import { CodeInputPage } from "../features/recording/components/CodeInputPage";
import { RecordPage } from "../features/recording/components/RecordPage";

export function App() {
  return (
    <AppProvider>
      <Router>
        <Routes>
          <Route path="/" element={<CodeInputPage />} />
          <Route
            path="/record"
            element={
              <ProtectedRoute>
                <RecordPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AppProvider>
  );
}
